export const validAliquota = (s: string): boolean => {
  const trimmed = s.trim();  
  if (trimmed.length === 0) return true;
  if (trimmed.length > 5) return false;  
  if (!/^\d+(\.\d{0,2})?$/.test(trimmed)) return false;  
  if (parseFloat(trimmed) >= 100) return false;  
  return true;
};